import { createContext } from 'preact';

/**
 * Context which an ancestor component can use to provide a value for the 'variant' property
 * of the descendant form fields.
 */
export const FormVariantContext = createContext<'default' | 'embedded' | undefined>('default');
